import "date-fns";
import React, { useState } from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "moment/locale/da";

export default props => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    return (
        <MuiPickersUtilsProvider utils={MomentUtils} locale="da">
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                margin="normal"
                id="date-picker-inline"
                label="Dato"
                value={props.date || selectedDate}
                onChange={date => {
                    setSelectedDate(date);
                    props.onChangeValue(date);
                }}
                KeyboardButtonProps={{
                    "aria-label": "change date"
                }}
            />
        </MuiPickersUtilsProvider>
    );
};
